/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";


export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 40px;
`

export const ContactsContainer = styled.div`
  width: 70%;
`

export const FilesContainer = styled.div`
  width: 30%;
`

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  `;
